import type { FileRouteTypes } from '@client/routeTree.gen';
import { useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useDeferredRoutesLoaded } from './useDeferredRoutesLoaded';

export function useGetRouteMatches() {
    const router = useRouter();
    const deferredRoutesLoaded = useDeferredRoutesLoaded();

    // Stable while the router and its route table are: lets callers memoise derived work such as
    // the navigation trees' access filtering. The table grows once, when the deferred route areas
    // load, and the new identity makes those callers recompute against it.
    return useCallback((path: FileRouteTypes['to']) => router.matchRoutes(path, {}), [router, deferredRoutesLoaded]);
}
